const PLUS_ONE_VARIANTS = ['\\+1', '\\+ 1', '\\+ one', 'plus one'];

function _parsePersonName(name) {
  let count = 0;
  let replacedName = name.trim();
  PLUS_ONE_VARIANTS.forEach(variant => {
    const regEx = new RegExp('(' + variant + ')', 'gi');
    if (replacedName.replace(regEx, '').length) {
      count += (replacedName.match(regEx) || []).length;
      replacedName = replacedName.replace(regEx, '');
    }
  });

  return {
    parsedName: replacedName.replaceAll('  ', ' ').trim(),
    isPlusOneOnName: count > 0,
  };
}

function _formatGuests(guests) {
  const people = guests.map(guest => {
    const {
      name,
      email_address,
      mailing_address,
      phone_number,
      has_plus_one,
      hasPlusOne: plusOne,
      source = '',
    } = guest;

    const { parsedName, isPlusOneOnName } = _parsePersonName(name);
    const hasPlusOne = has_plus_one || plusOne || isPlusOneOnName;

    return {
      name: parsedName,
      email_address,
      mailing_address,
      phone_number,
      hasPlusOne,
      isChild: !!guest.is_child,
      source,
    };
  });

  return people;
}

function _formatForMoreThanTwoMembers(people) {
  const names = people.map(person => person.name).join(', ');
  const indexStart = names.lastIndexOf(', ');
  const indexLength = 2;
  const indexEnd = indexStart + indexLength;
  return names.substr(0, indexStart) + ' & ' + names.substr(indexEnd);
}

function _determineIfLastnameIsConsistent(people) {
  const firstPerson = people[0].name;
  const firstPersonLastname = firstPerson.split(' ').slice(-1)[0];

  const onePersonDontHaveLastname = people.some(
    ({ name }) => !name.toLowerCase().includes(firstPersonLastname.toLowerCase())
  );

  return onePersonDontHaveLastname ? false : firstPersonLastname;
}

function _formatForFamily(people, lastName) {
  const parsedPeople = people.map((person, i, { length }) => {
    let name = person.name;

    if (i !== length - 1) {
      name = name.replace(' ' + lastName, '');
    }

    return Object.assign({}, person, { name });
  });

  return parsedPeople;
}

export const formulatePartyName = guests => {
  let people = _formatGuests(guests);
  if (people.length === 1) {
    return people[0].name + (people[0].hasPlusOne ? ' +1' : '');
  }

  const lastName = _determineIfLastnameIsConsistent(people);

  if (lastName) {
    people = _formatForFamily(people, lastName);
  }

  return _formatForMoreThanTwoMembers(people);
};
